function posixify(path) {
  return path.trim().replaceAll(/[/\\]+/g, "/");
}
function $slashWrapEnd(path) {
  if (!path.endsWith("/")) {
    return `${path}/`;
  }
  return path;
}
function slashWrapEnd(path) {
  return $slashWrapEnd(posixify(path));
}
function $slashWrapStart(path) {
  if (!path.startsWith("/")) {
    return `/${path}`;
  }
  return path;
}
function slashWrapStart(path) {
  return $slashWrapStart(posixify(path));
}
function slashWrap(path) {
  return $slashWrapStart($slashWrapEnd(posixify(path)));
}
function $slashTrimStart(path) {
  return path.replace(/^\/+/, "");
}
function slashTrimStart(path) {
  return $slashTrimStart(posixify(path));
}
function $slashTrimEnd(path) {
  return path.replace(/\/+$/, "");
}
function slashTrimEnd(path) {
  return $slashTrimEnd(posixify(path));
}
function slashTrim(path) {
  return $slashTrimEnd($slashTrimStart(posixify(path)));
}
const guard = new URL("http:/*     */
function parseUrl(url, base = guard) {
  return new URL(url, base);
}
function isURL(value) {
  if (value instanceof URL) {
    return true;
  }
  try {
    if (typeof value === "object" && value) {
      return !!new URL(value.toString());
    }
  } catch {
  }
  return false;
}
function webJoin(...paths) {
  return paths.reduce((base, path) => {
    base.pathname = slashWrapEnd(base.pathname);
    const next = slashTrimStart(isURL(path) ? path.pathname : path);
    return new URL(parseUrl(next, base).pathname, parseUrl(path, base));
  }, guard);
}
function stripOrigin(url) {
  const parsed = isURL(url) ? url : new URL(url, guard);
  return parsed.href.slice(parsed.origin.length);
}

export { isURL, parseUrl, posixify, slashTrim, slashTrimEnd, slashTrimStart, slashWrap, slashWrapEnd, slashWrapStart, stripOrigin, webJoin };
/*                              */
